export default __webpack_public_path__ + "static/8c025621-11f1-4af4-8dfa-69eb993b51b9-9bc2be006eaf0da03d3db6ae4d11b236.woff";